import { PaymentCardFormat, CreditCardTypes } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { FormInputField, lt } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { PaymentCardExpirationField } from '../../../common/PaymentCardExpirationField';
import { useAccountingGetConfigurationAcceptedManualPaymentCardTypesSuspense } from '../../../../queries';
import { RecordCardFormField } from './schema';

export const RecordCardFormFields = () => {
    const { data: acceptedManualPaymentCardTypes } =
        useAccountingGetConfigurationAcceptedManualPaymentCardTypesSuspense();

    const acceptedCardTypes = Object.values(acceptedManualPaymentCardTypes);

    return (
        <Stack spacing="300" vertical>
            <EnumSelectField
                required
                enumClass={CreditCardTypes}
                enumPrefix="CreditCardTypes"
                enabledValues={acceptedCardTypes}
                showEmptyValue
                label={lt('Type')}
                name={RecordCardFormField.PaymentCardType}
                helper={lt('ProcessPaymentExternalPaymentsCardPaymentCardTypeHint')}
            />

            <Stack spacing="100" distribution="space-between">
                <StackItem grow>
                    <FormInputField
                        name={RecordCardFormField.PaymentCardNumber}
                        label={lt('LastFourDigits')}
                        helper={lt('ProcessPaymentExternalPaymentsCardPaymentCardNumber4DigitsHint')}
                        placeholder="1234"
                        maxLength={4}
                        inputMode="numeric"
                        pattern="\d*"
                        required
                    />
                </StackItem>
                <StackItem grow>
                    <PaymentCardExpirationField
                        name={RecordCardFormField.PaymentCardExpiration}
                        label={lt('ProcessPaymentMewsPaymentsCardExpirationInputLabel')}
                        helper={lt('ProcessPaymentExternalPaymentsCardPaymentCardExpirationHint')}
                    />
                </StackItem>
            </Stack>
            <FormInputField name={RecordCardFormField.PaymentCardHolderName} label={lt('CardHolderName')} />

            <EnumSelectField
                required
                enumClass={PaymentCardFormat}
                enumPrefix="PaymentCardFormat"
                label={lt('Format')}
                name={RecordCardFormField.PaymentCardFormat}
                defaultValue={PaymentCardFormat.Physical}
            />
        </Stack>
    );
};
